import InputSearch from "../../ui/InputSearch";

export default function GlobalSearch({
  searchGlobalPlaceholder,
  globalSearch,
  onGlobalSearchChange,
}) {
  return (
    <InputSearch
      placeholder={searchGlobalPlaceholder}
      value={globalSearch}
      onChange={onGlobalSearchChange}
      customClassName="responsive-w input-search"
    />
  );
}
